// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__37z0M","label":"styles_label__3RliH","headerLabel":"styles_headerLabel__36VD3","typeFilter":"styles_typeFilter__2evL6"};